<template>
  <div class="panel panel-danger" v-show="error.error">
    <div class="panel-heading">
      <div class="panel-title">
        <span class="glyphicon glyphicon-exclamation-sign"
              aria-hidden="true"></span>
        <slot name="title"><strong v-html="error.title"></strong></slot>
      </div>
    </div>
    <div class="panel-body">
      <p class="error-heading text-justify">
        <slot name="heading">
          <span v-html="error.heading">
          </span>
        </slot>
      </p>
      <p class="text-justify">
        <slot name="default"><span v-html="error.text"></span></slot>
        <span v-if="error.contact">
          Si le problème persiste, n'hésitez pas à nous contacter via le
          <router-link to="/contact">formulaire de contact</router-link>.
        </span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sui-error-panel',

  props: {
    error: {
      type: Object,
      default: () => {
        return {
          error: true,
          title: 'Attention !',
          heading: `Une erreur s'est produite.`,
          text: '',
          contact: true
        }
      }
    }
  }
}
</script>
<style scoped lang="less">
@import "~variables";

.panel-title {
  font-size: 140%;

  .glyphicon {
    margin-right: 1rem;
  }
}

.error-heading {
  color: @brand-danger;
  font-size: 120%;
}

</style>
